import { useSelector } from 'react-redux'
import { selectContext } from 'selectors/auth'
import { useCurrentPractice } from '../../../../contexts/PracticeContext'

export const READ_ONLY_USER_MESSAGE =
	'You do not have permissions to access this feature. Please contact your admin team.'

export const useReadOnlyUser = () => {
	const { currentPracticeObject } = useCurrentPractice()
	const context: Context = useSelector(selectContext)
	const currentUser = context?.user as User

	const isLoading = !currentPracticeObject?.id || !currentUser
	const isReadOnly = Boolean(currentUser?.isReadOnly)

	return {
		isLoading,
		isReadOnly,
		currentUser,
		currentPracticeObject
	}
}
